import cx from 'classnames';
import Placholder from 'assets/img/img-user-default.png';
import styles from 'partials/avatar.module.scss';

export const Avatar = ({ src, alt = '', className }) => {
	return (
		<div className={cx(styles.box, className)}>
			<img src={src ?? Placholder} alt={alt} className={styles.image} />
		</div>
	);
};
